import React from "react";
import { useNavigate } from "react-router-dom";
//Redux
import { useDispatch, useSelector } from "react-redux";
import { setComponentActive, updateCart } from "./../../reducers/userConfigSlice";
import { Button } from "@delibrandev/utils";
import "./style.css";
import { useEffect } from "react";
import Success from "../../assets/orders/order-success.svg";
import Fail from "../../assets/orders/order-fail.svg";

export const ResponsePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const payment = useSelector((state) => state.aplicationConfig.userConfig.payment);

  /*********** API REQUESTS ************/
  const queryGet = async () => {};

  useEffect(() => {
    console.log("useEffect");
    queryGet();
    payment !== null && dispatch(updateCart({ ShoppingCartProducts: [] }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const CheckoutAction = () => {
    const handleMenu = (component) => {
      dispatch(setComponentActive(component));
      navigate("/" + component);
    };

    const handleRedirect = () => {
      if (payment == null) {
        handleMenu("products");
      } else {
        handleMenu("order-tracking/" + payment.orderId);
      }
    };

    return (
      <div className="checkout-resume">
        <div className="checkout-resume-container">
          <img
            src={payment != null ? Success : Fail}
            alt={payment != null ? "Pedido en preparación" : "Pedido fallido"}
            className="checkout-resume-image"
          />
          <div className="checkout-resume-text">
            <p className={`checkout-resume-title ${payment != null ? "title-success" : "title-fail"}`}>
              {payment != null ? "Tu pedido esta en preparación" : "¡Oh Oh! Hubo un problema con el pago"}
            </p>
            <p className="checkout-resume-subtitle">
              {payment != null
                ? "Estamos trabajando para que todo esté listo lo más pronto posible."
                : "Revise si su tarjeta tiene fondos suficientes, de lo contrario cambie método de pago."}
            </p>
          </div>
        </div>
        <div className="checkout-resume-total">
          <Button
            text={payment != null ? "Seguimiento del pedido" : "Volver a intentarlo"}
            icon={null}
            customClass={payment != null ? "customButtonOrderSuccess customButtonColor2" : "customButtonOrderFailed customButtonColor2"}
            action={() => handleRedirect()}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="checkout-container-order">
      <CheckoutAction />
    </div>
  );
};
